import React, { useState } from "react";
import {
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import { MdOutlineDelete } from "react-icons/md";
import { eliminarSandvans } from "../../helpers/api.helper";

const EliminarSandvan = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const { sandvan, initData, user } = props;

  const toast = useToast();

  const handleEliminarRegistro = async () => {
    setLoading(true);
    let res = await eliminarSandvans({
      id: sandvan.idSandVan,
    });
    if (res.status === 200) {
      toast({
        status: "success",
        isClosable: true,
        title: "SandVan eliminada correctamente",
        duration: 3000,
      });
      initData();
      onClose();
    } else {
      toast({
        title: "Error al eliminar SandVan",
        description: res.data,
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Tooltip label="Eliminar SandVan">
        <IconButton
          variant="link"
          icon={<MdOutlineDelete fontSize="20px" />}
          onClick={onOpen}
          _hover={{ color: "brand.naranja" }}
        />
      </Tooltip>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        size="lg"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              color="brand.gris_primario"
              fontSize="lg"
              fontWeight="bold"
            >
              Eliminar SandVan
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro que desea eliminar el{" "}
              <strong>{sandvan.codigoSandVan}</strong>?
              <br />
              Esta acción no se puede revertir.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} variant="link" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                bg="brand.naranja"
                onClick={handleEliminarRegistro}
                ml={3}
                isDisabled={loading || user.idRol === "usuarioIT"}
                color="white"
              >
                Eliminar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default EliminarSandvan;
